export var Palette;
(function (Palette) {
  Palette["Positive"] = "positive";
  Palette["Negative"] = "negative";
})(Palette || (Palette = {}));
export var PALETTES = Object.values(Palette);
export var DEFAULT_PALETTE = Palette.Positive;